<template>
  <v-dialog
    v-model="innerVal"
    max-width="90vh"
  >
    <v-card
      rounded="0"
      flat
      tile
      class="overflow-hidden"
    >
      <v-row
        justify="center"
        align="center"
      >
        <v-img
          contain
          :src="image"
          max-height="90vh"
        ></v-img>
        <v-icon
          @click="innerVal = false"
          style="position: absolute; top: 10px; right: 10px;"
        >
          mdi-close
        </v-icon>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'BaseImageDialog',

    props: {
      value: { type:Boolean, default:false },
      image: { type: String }
    },

    data() {
      return {
        innerVal: this.value
      }
    },

    watch: {
      value(val) {
        this.innerVal = val
      },
      innerVal(val) {
        this.$emit('input', val)
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>